import moment from "moment"
import { envConfig, globalConfig } from "../services/api";
import { isAndroid, isIOS, isMobile, osVersion } from "react-device-detect";
export const modifyDate = (orderDate) => {
    const year = new Date(orderDate).getFullYear();
    return year !== 1 ? moment(orderDate).format("DD MMM YYYY") : "";
  };
 
  export const setNumberPrecision = (val) => {
    return val?.toFixed(2);
  };
  const formatDecimals = (num) => {
    const calcDec = Math.pow(10, 1);
    return Math.trunc(num * calcDec) / calcDec;
  }

  export const formattedDate = (timestamp) => {
    if (!timestamp) return ''
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleString('en-US', { 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric', 
      hour: 'numeric', 
      minute: 'numeric', 
      hour12: true 
    });
  };

  const checkFloatingValue = (formattedData) => {
    return Number.isInteger(formattedData) ? formattedData : formatDecimals(formattedData)
  }

  export const checkDataSize = (dataSizeInBytes) => {
    const bytesInOneMB = 1000 * 1000; // 1 MB = 1024 KB, 1 KB = 1024 bytes
    const bytesInOneGB = bytesInOneMB * 1000; // 1 GB = 1024 MB
    if (dataSizeInBytes >= bytesInOneGB) {
      // Data is in GB
      const dataSizeInGB = dataSizeInBytes / bytesInOneGB;
      return checkFloatingValue(dataSizeInGB) + " GB";
    } else if (dataSizeInBytes >= bytesInOneMB) {
      // Data is in MB
      const dataSizeInMB = dataSizeInBytes / bytesInOneMB;
      return checkFloatingValue(dataSizeInMB) + " MB";
    } else if(dataSizeInBytes >= 1000) {
      // Data is in bytes
      const dataSizeInMB = dataSizeInBytes / 1000;
      return checkFloatingValue(dataSizeInMB) + " KB";
    } else {
      return 0 + " KB"
    }
  };

  export const displayBase64 = (image)=>"data:image/png;base64,"+image

export const shareEsimDetailsHandler = async ({
  activeBundle,
  account,
  toast
}) => {  
  
  const description = activeBundle?.description || "";
  const orderId = activeBundle?.orderId || "";
  const shareData = {
    title: account.ACTN0123,
    text: `${account.ACTN0124}
  
  ${account.ACTN0125} ${description}
  
  ${account.ACTN0126} ${envConfig.REACT_APP_BASE_URL}/esim/${orderId}
  
  ${account.ACTN0127}`,
  };

  try {
    if (navigator.share) {
      await navigator.share(shareData);
    } else {
      await navigator.clipboard.writeText(shareData.text);
      // alert('Share not supported. Details copied to clipboard.');
          toast.current.show({
            severity: "success",
            summary: "Copied",
            detail: account?.ACTN0128,
            life: globalConfig?.toastDisplayTime,
          });
    }
  } catch (err) {
    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: account?.ACTN0129,
      life: globalConfig?.toastDisplayTime,
    });
  }
};

 export const isBase64Image = (image) => {
    if(image?.startsWith('iVBORw0KGgoAAAANSUhEUg') || image?.startsWith('/9j/4AAQSkZJRgA')){
      return true
    }
    return false
  }

export const getImageSrc = (image, local)=> image?.startsWith('iVBORw0KGgoAAAANSUhEUg') || image?.startsWith('/9j/4AAQSkZJRgA') ? "data:image/png;base64,"+image : local


export const rcTransformData = data => data?.map(i => i?.country?.name).sort();
export const snTransformData = data => data?.map(i => {
  return `${i?.name} ${!!i?.speeds && i?.speeds?.length === 0 ? '':`(${i?.speeds?.join('/')})`}`
})

export const getPhoneObj = (phoneValue, isAuth, userData, formData) => {
  const loggedInPhone = (isAuth && userData.phone?.localPhoneNumber) ? userData.phone?.localPhoneNumber : "";
  const loggedInCallingCode = (isAuth && userData.phone?.callingCode) ? userData.phone?.callingCode : "";
  const phone = {
    localPhoneNumber: phoneValue ? phoneValue : formData?.callingCode ? "" : loggedInPhone,
    callingCode: formData?.callingCode ? formData?.callingCode : loggedInCallingCode
  }
  return phone;
}

export const checkProviderCode = (providerCode) => {
  if(providerCode) {
    return !globalConfig?.restrictProviders?.includes(providerCode);
  }
  return true;
};

export const currencyLocaleMap = {
  HUF: "Ft",
  JPY: "¥",
  KRW: "₩",
  RUB: "₽",
  TRY: "₺",
};

export const formatCurrency = (currencyCode, price) => {
  try {
    const formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "narrowSymbol",

      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);

    const customSymbol = currencyLocaleMap[currencyCode];
    if (customSymbol) {
      formatted.replace(currencyCode, customSymbol);
    }
    return formatted;
  } catch (err) {
    return `${globalConfig?.defaultCurrency}${price?.toFixed(2)}`;
  }
};

export const compareIOSVersions = () => {
  const v1 = osVersion;
  const v1Parts = v1.split(".").map(Number);
  const v2Parts = globalConfig.iosVersionForActivateEsim.split(".").map(Number);

  while (v1Parts.length < v2Parts.length) v1Parts.push(0);
  while (v2Parts.length < v1Parts.length) v2Parts.push(0);

  for (let i = 0; i < v1Parts.length; i++) {
    if (v1Parts[i] > v2Parts[i]) {
      return true;
    }
    if (v1Parts[i] < v2Parts[i]) {
      return false; // v1 is less
    }
  }

  return true; // They are equal, return true for "greater or equal"
};

export const showActivateEsimUrl = isMobile && ((isIOS && compareIOSVersions()) || (isAndroid && osVersion >= 10));
const platform = isAndroid ? "android" : "apple";
export const esimActivateUrl = ({smdpAddress, matchingId}) => `https://esimsetup.${platform}.com/esim_qrcode_provisioning?carddata=LPA:1$${smdpAddress}$${matchingId}`